var Conversation = (function(Conversation) {

  var $window = $(window);

  Conversation.List = {
    init: function() {
      this.list = $('.cw-conversation-list');
      if (!this.list.length) {
        return; // ¯\_(ツ)_/¯
      }

      this.template = tmpl( document.getElementById('tmpl-conversation-row').innerHTML );

      // To lock the scroll event
      this.fetching = false;

      var params = parseQueryString(document.location.search);
      this.page = params.page || 1;
      this.per_page = params.per_page || undefined;
      this.last_page = false;

      this.attachScrollEvent();
      this.attachDelegatedEvents();
    },

    attachScrollEvent: function() {
      var self = this;
      $window.on('scroll.conversation_list', throttle(function(ev) {
        if (self.fetching || self.last_page) {
          return;
        }
        var pos = self.list[0].getBoundingClientRect();
        if (pos.bottom <= $window.height()) {
          self.fetching = true;
          self.showSpinner();
          $.ajax({
            url: document.location,
            method: 'GET',
            data: {
              page: self.page + 1 // Don't update the page yet, in case the request fails
            },
            dataType: 'json'
          }).then(function(response) {
            self.fetching = false;
            self.page += 1;
            self.hideSpinner();
            if (response.data.length) {
              self.addLines(response.data);
            } else {
              self.last_page = true;
              $window.off('scroll.conversation_list');
            }

          });
        }
      }, 200));
    },

    attachDelegatedEvents: function() {
      var self = this;

      // Be sure we don't go to the row event when we click a link
      this.list.on('click', 'a', function(e) {
        e.stopPropagation();

        var $this = $(this);
        var action = $this.data('action');
        if (action) {
          e.preventDefault();
          var row = $this.closest('tr');
          self['do' + toCamelCase(action, true)].call(self, row); // self.doDelete(row), self.doArchive(row)...
        }
      });

      // Make the whole row clickable
      this.list.on('click', 'tr', function(e) {
        e.preventDefault();
        var target = $(this).find('a').first().prop('href');
        if (e.metaKey || e.ctrlKey) {
          window.open(target);
        } else {
          document.location = target;
        }
      });

    },

    addLines: function(lines) {
      var self = this;
      var tbody = this.list.find('tbody');
      lines.forEach(function(line, i) {
        var html = self.template($.extend({}, line, {
          is_archive: document.location.search.indexOf('label=archive') != -1,
          i18n_archive: I18n.translate('archive'),
          i18n_delete: I18n.translate('delete'),
          i18n_move_to_inbox: I18n.translate('move_to_inbox'),
          status: line.item_status,
          status_name: line.item_status_name
        }));
        tbody.append(html);
      });
    },

    showSpinner: function() {
      this.list.addClass('cw-spinner cw-spinner-on');
    },

    hideSpinner: function() {
      this.list.removeClass('cw-spinner cw-spinner-on');
    },

    hideRow: function(row) {
      if (Modernizr.testProp('transition')) {
        row.addClass('cw-conversation-hide');
        row.on('transitionend', function() { row.hide(); });
      } else {
        row.hide();
      }
    },

    doToggleArchive: function(row) {
      var id = row.data('id');
      if (!id) {
        return;
      }

      $.ajax({
        url: '/messages/' + id + '/archive',
        data: { '_method': 'put' },
        method: 'post',
        dataType: 'json'
      });

      this.hideRow(row);
    }
  };


  function parseQueryString(string) {
    if (string.indexOf('?') === 0) {
      string = string.substr(1);
    }

    return string.split(/&|;/).reduce(function(obj, pair) {
      var keyval = pair.split("=");
      obj[decodeURIComponent(keyval[0])] = decodeURIComponent(keyval[1]);
      return obj;
    }, {});
  }

  // https://remysharp.com/2010/07/21/throttling-function-calls
  function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
      var context = scope || this;

      var now = +new Date,
          args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  }

  function toCamelCase(string, capitalize) {
    string = string.replace(/_\w/g, function(m) {
      return m[1].toUpperCase();
    });

    if (capitalize) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return string;
    }
  }

  $(document).ready(function() {
    Conversation.List.init();
  });

  return Conversation;

})(Conversation || {});
